import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import { TIMEFRAME } from '../../main/constants'
import { useCheckNonIdeaChartMissingConfig } from '../../main/hooks/use-check-non-idea-chart-missing-config'
import { ChartLayoutWithGlobalState, FREE_DATE_RANGES } from '../charts-lib'
import { decodeQueryString } from '../queryString'
import { SpecificChartFunctionality } from '../shared/chartLayoutConfig'
import { ready } from '../shared/ready'
import FundamentalCharts from './fundamentalCharts'
import './quote'
import { QuoteMenu } from './quote-menu'
import Statements from './statements'
import { getChartLayoutSizeConfig, useChartLayoutWidthWatch } from './use-chart-layout-width-watch'
import { useStockDetailUpdater } from './use-stock-detail-updater'

const QuoteMenuPortal = ({ isStockDetailUpdating }: { isStockDetailUpdating: boolean }) => {
  const quoteMenuElements = document.getElementsByClassName('quote-menu')
  const quoteMenuHtmlElements = Array.from(quoteMenuElements).filter((el) => el instanceof HTMLElement) as HTMLElement[]

  if (quoteMenuHtmlElements.length > 0) {
    return (
      <>
        {quoteMenuHtmlElements.map((quoteMenuElement: HTMLElement, quoteMenuIndex: number) => {
          const { ischarttas, isscreener } = quoteMenuElement.dataset
          return ReactDOM.createPortal(
            <QuoteMenu
              index={quoteMenuIndex}
              isChartTAS={ischarttas === '1'}
              isScreener={isscreener === '1'}
              isInteractiveChart={quoteMenuIndex === 0}
              isStockDetailUpdating={isStockDetailUpdating}
            />,
            quoteMenuElement
          )
        })}
      </>
    )
  }
  return null
}

const ChartLayoutPortal = () => {
  useChartLayoutWidthWatch()
  const chartEl = document.getElementById('chart')
  const chartConfig = window.globalChartConfig

  if (chartEl && chartConfig) {
    const { p } = decodeQueryString<{ p?: TIMEFRAME }>()
    return ReactDOM.createPortal(
      <ChartLayoutWithGlobalState
        config={{
          ...chartConfig,
          ...getChartLayoutSizeConfig(p, chartConfig),
          specificChartFunctionality: SpecificChartFunctionality.quotePage,
          charts: chartConfig.charts.map((chart) => ({
            ...chart,
            dateRange:
              FinvizSettings.hasUserPremium || FREE_DATE_RANGES.includes(chart.dateRange) ? chart.dateRange : null,
          })),
        }}
        parentElement={chartEl}
      />,
      chartEl
    )
  }
  return null
}

const ReactComponentsContainer = () => {
  const { isStockDetailUpdating } = useStockDetailUpdater()
  const { ty } = decodeQueryString()
  const isPerfQuotePage = ty === 'p'
  const hasConfig = window.globalChartConfig

  useCheckNonIdeaChartMissingConfig()

  return (
    <>
      {hasConfig || isPerfQuotePage ? <QuoteMenuPortal isStockDetailUpdating={isStockDetailUpdating} /> : null}
      {hasConfig && <ChartLayoutPortal />}
    </>
  )
}

ready(() => {
  const statementsEl = document.getElementById('statements')
  if (statementsEl && window['fetch']) {
    ReactDOM.render(<Statements />, statementsEl)
  }

  const faEl = document.getElementById('js-quote-fa')
  if (faEl) {
    ReactDOM.render(<FundamentalCharts />, faEl)
  }

  const reactRootElement = document.getElementById('react-root')
  if (reactRootElement) {
    ReactDOM.render(
      <BrowserRouter>
        <ReactComponentsContainer />
      </BrowserRouter>,
      reactRootElement
    )
  }
})

const revealRatingButtonsCollection = document.getElementsByClassName('js-reveal-ratings-button')
const revealRatingButtons = Array.from(revealRatingButtonsCollection) as HTMLButtonElement[]
revealRatingButtons.forEach((revealRatingButton) => {
  revealRatingButton.onclick = (e) => {
    e.preventDefault()
    const tableElement = revealRatingButton.closest('.js-table-ratings')

    tableElement?.querySelectorAll('tr.hidden').forEach((rating) => {
      rating.classList.remove('hidden')
    })

    revealRatingButton.classList.add('hidden')
    window.gtag && window.gtag('event', 'click', { event_category: 'reveal-ratings' })
  }
})
